module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-35.7b6c7e0f.png";